export const PageLoader = () => (
  <div className="flex min-h-[60vh] items-center justify-center">
    <span className="animate-pulse font-mono text-[11px] tracking-[0.4em] text-ink/40">LOADING…</span>
  </div>
);
